import React, { Fragment, useEffect, useState } from "react";
import downloadIcon from "../../assets/img/Icon feather-upload-cloud.png";
import eyeIcon from "../../assets/img/eye.png";
import {
  getFilePreview,
  getDsiputeDwonloadFiles,
  getDsiputePreviewFiles,
} from "../../adapters/apis/lookups/lookups";
import useFileHandler from "../../hooks/useFileHandler";

import infoIconSvg from "../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../shared/form/InfoPopover";

function InputElement(props) {
  const { handleDownload, handlePreviewClick } = useFileHandler();
  const [fileName, setFileName] = useState(props?.fileName);
  const [fileError, setFileError] = useState(!!props.pText);
  const checkType = props.inputType;

  useEffect(() => {
    if (props.pText) {
      setFileError(true);
    }
  }, [props.pText]);

  const errorBorder = props.pText ? " invalid" : "";
  const fileErrorBorder = fileError ? " invalid" : "";

  const [stateType, setStateType] = useState("password");
  const handleClick = () =>
    setStateType(stateType === "text" ? "password" : "text");

  const validateManySpace = (string) => {
    return /[ ]{2,}/.test(string);
  };
  const validateRegax = (e) => {
    if (!validateManySpace(e.target.value)) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        e.target.value,
        props.index,
        props.buildingIndex,
        props.floorIndex,
      );
    }
  };

  const customNumberRules = (e) => {
    let is_valid = true;
    if (
      parseInt(e.target.value) < 1 ||
      e.target.value.toString().includes("-") ||
      e.target.value.toString() === " "
    ) {
      return;
    }
    if (e.target.value.toString() === "" && props.value.length !== 1) {
      return "";
    }

    // check if it's found any عدد words you shouldn't accept '.'
    if (
      props.labelText.includes("عدد") &&
      e.target.value.toString().includes(".")
    ) {
      return;
    } else {
      if (e.target.value.toString().includes("."))
        if (e.target.value.toString().split(".")[1].length > 2) {
          e.target.value = parseFloat(e.target.value).toFixed(2);
        }
    }

    if (e.target.value.length > props.maxLength) {
      return;
    }

    if (is_valid)
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        e.target.value,
        props.index,
        props.buildingIndex,
      );
  };

  if (checkType === "number") {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <input
            type={props.inputType}
            className={props.inputClassName + errorBorder}
            id={props.inputID}
            value={props.value}
            disabled={props.disabled}
            min={props.min ? props.min : 1}
            max={props.max}
            pattern={props.pattern}
            maxLength={props.maxLength}
            placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
            onChange={(e) => customNumberRules(e)}
          />
          {props.pText && <p className={props.pClassName}>{props.pText}</p>}
        </div>
      </Fragment>
    );
  } else if (checkType === "password") {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <input
            autoComplete="new-password"
            type={stateType}
            className={props.inputClassName + errorBorder}
            id={props.inputID}
            value={props.value}
            disabled={props.disabled}
            min={props.min ? props.min : 1}
            max={props.max}
            maxLength={props.maxLength}
            placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
            pattern={
              props.allowedPattern instanceof RegExp
                ? props.allowedPattern.source
                : props.allowedPattern
            }
            onChange={(e) => {
              const val = e.target.value;
              const isValid =
                !props.allowedPattern ||
                val === "" ||
                props.allowedPattern.test(val);
              if (isValid) {
                if (props.customChange) {
                  validateRegax(e);
                }
                props.onChange(
                  props.parentCompenent,
                  props.compenent,
                  props.name,
                  val,
                  props.index,
                  props.buildingIndex,
                  props.floorIndex,
                );
              }
            }}
          />
          <div className="password__show" onClick={handleClick}>
            {stateType === "text" ? (
              <i className="fa-solid fa-eye-slash"></i>
            ) : (
              <i className="fa-solid fa-eye"></i>
            )}
          </div>

          {props.pText &&
            (Array.isArray(props.pText) ? (
              props.pText.map((item, index) => (
                <p key={index} className={props.pClassName}>
                  {item}
                </p>
              ))
            ) : (
              <p className={props.pClassName}>{props.pText}</p>
            ))}
        </div>
      </Fragment>
    );
  } else if (checkType !== "file") {
    return (
      <Fragment>
        <div className={`${props.mb4} position-relative`}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          {props?.popover && (
            <InfoPopover content={props.popover.content}>
              <img
                src={infoIconSvg}
                alt="info"
                width="18"
                height="18"
                style={{
                  display: "block",
                  marginRight: "10px",
                }}
              />
            </InfoPopover>
          )}
          {props.profile ? (
            <div className={props.profileDiv}>
              <input
                type={props.inputType}
                className={props.inputClassName + errorBorder}
                id={props.inputID}
                value={props.value}
                disabled={props.disabled}
                min={props.min}
                max={props.max}
                maxLength={props.maxLength}
                style={props.styleInputProfile}
                placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
                onChange={(e) => {
                  if (props.allowedPattern) {
                    if (
                      e.target.value === "" ||
                      props.allowedPattern.test(e.target.value)
                    ) {
                      if (props.customChange) {
                        validateRegax(e);
                        if (props.onChange) props.onChange(e);
                      } else {
                        return validateRegax(e);
                      }
                    }
                  } else {
                    if (props.customChange) {
                      validateRegax(e);
                      if (props.onChange) props.onChange(e);
                    } else {
                      return validateRegax(e);
                    }
                  }
                }}
                pattern={
                  props.allowedPattern instanceof RegExp
                    ? props.allowedPattern.source
                    : props.allowedPattern
                }
                // customChange={props.customChange}
              />

              {props.isButton && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={props.buttonOnClick}
                  style={props.styleButtonProfile}
                  disabled={props.buttonDisabled}
                >
                  {props.buttonText}
                </button>
              )}
            </div>
          ) : (
            <input
              type={props.inputType}
              className={props.inputClassName + errorBorder}
              id={props.inputID}
              value={props.value}
              disabled={props.disabled}
              min={props.min}
              max={props.max}
              maxLength={props.maxLength}
              placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
              onChange={(e) => {
                if (props.allowedPattern) {
                  if (
                    e.target.value === "" ||
                    props.allowedPattern.test(e.target.value)
                  ) {
                    if (props.customChange) {
                      validateRegax(e);
                      if (props.onChange) props.onChange(e);
                    } else {
                      return validateRegax(e);
                    }
                  }
                } else {
                  if (props.customChange) {
                    validateRegax(e);
                    if (props.onChange) props.onChange(e);
                  } else {
                    return validateRegax(e);
                  }
                }
              }}
              pattern={
                props.allowedPattern instanceof RegExp
                  ? props.allowedPattern.source
                  : props.allowedPattern
              }
              style={props.style}
              // customChange={props.customChange}
            />
          )}

          {props.isIcon && (
            <div
              className="position-absolute d-flex gap-2"
              style={{ top: "46px", left: "10px" }}
            >
              <button
                style={{ border: "none" }}
                onClick={() => {
                  if (props.serverSide) {
                    props.previewFunction();
                  } else if (props.fileUrl) {
                    handlePreviewClick(props.fileUrl, null, getFilePreview);
                  } else {
                    handlePreviewClick(
                      props.idDownload,
                      props.filedDownload,
                      getDsiputePreviewFiles,
                      props.declarationId,
                    );
                  }
                }}
              >
                <img src={eyeIcon} alt="eyeIcon" className="img-fluid" />
              </button>
              {/* Vertical Divider */}
              <div
                style={{
                  width: "1px",
                  height: "24px",
                  backgroundColor: "#ccc",
                }}
              ></div>
              <button
                onClick={() => {
                  if (props.serverSide) {
                    props.downloadFunction();
                  } else if (props.fileUrl) {
                    handleDownload(props.fileUrl, null, getFilePreview);
                  } else {
                    handleDownload(
                      props.idDownload,
                      props.filedDownload,
                      getDsiputeDwonloadFiles,
                      props.declarationId,
                    );
                  }
                }}
                style={{ border: "none", background: "transparent" }}
              >
                <img
                  src={downloadIcon}
                  alt="downloadIcon"
                  className="img-fluid"
                />
              </button>
            </div>
          )}
          {props.pText && <p className={props.pClassName}>{props.pText}</p>}
          {props.pVerificationText && (
            <p className={props.pVerificationClass}>
              {props.pVerificationMessage}
            </p>
          )}
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}

            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <div
            className={`${props.inputIcon} input-icon-custom${
              props.dimDisabled && props.disabled ? " disabled" : ""
            }`}
          >
            <div className={`file-wrapper${fileErrorBorder}`}>
              <input
                ref={props.fileInputRef}
                type="file"
                disabled={props.dimDisabled ? props.disabled : false}
                className={
                  props.inputClassName + fileErrorBorder + " fileCustom"
                }
                id={props.inputID}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setFileError(false);
                    props.onChange(
                      props.parentCompenent,
                      props.compenent,
                      props.name,
                      file,
                      props.index,
                      props.buildingIndex,
                      props.floorIndex,
                      props.fileInputRef,
                    );
                    setFileName(file ? file.name : "إرفاق ملف");
                  }
                }}
              />
              <span className="file-overlay overflow-hidden">
                {props.fileName || fileName}
              </span>
            </div>

            {props.labelHint && (
              <p className={props.hintClass}>{props.labelHint}</p>
            )}
            {props.pText && !props.hideErrorMessage && (
              <p className={props.pClassName}>{props.pText}</p>
            )}

            <i
              className={props.icon}
              onClick={() => {
                if (props.dimDisabled && props.disabled) return;
                if (props.fileInputRef?.current) {
                  props.fileInputRef.current.click();
                }
              }}
              style={{
                cursor:
                  props.dimDisabled && props.disabled
                    ? "not-allowed"
                    : "pointer",
              }}
            ></i>
            {fileName !== "إرفاق ملف" &&
              props?.fileName !== "إرفاق ملف" &&
              props?.deleteFunction && (
                <i
                  className="fa-solid fa-trash fa-lg text-danger"
                  onClick={() => {
                    if (props?.deleteFunction) {
                      props?.deleteFunction();
                    }
                    setFileName("إرفاق ملف");
                  }}
                  style={{
                    cursor: "pointer",
                    marginTop: "10px",
                    marginLeft: "30px",
                  }}
                ></i>
              )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InputElement;
